<i18n>
{
  "ru": {
    "signUp": "Регистрация",
    "name": "Имя:",
    "city": "Город:",
    "confirmPassword": "Подтверждение пароля:",
    "done": "Зарегистрироваться",
    "close": "Закрыть"
  },
  "uk": {
    "signUp": "Реєстрація",
    "name": "Ім'я:",
    "city": "Місто:",
    "confirmPassword": "Підтвердження паролю:",
    "done": "Зареєструватися",
    "close": "Закрити"
  }
}
</i18n>

<template>
  <div>
    <a class="nav-link" @click.prevent="showModal" href="#">{{
      $t("signUp")
    }}</a>
    <b-modal
      class="as-modal"
      ref="modal"
      lazy
      hide-footer
      static
      no-close-on-backdrop
      :title="$t('signUp')"
    >
      <div class="d-block">
        <b-form class="as-form" v-on:submit.prevent="sendReg">
          <b-form-group label="Email:" label-for="email">
            <b-form-input
              type="email"
              name="email"
              :state="stateEmail"
              v-model.trim="form.email"
            ></b-form-input>
            <span
              class="text-danger"
              v-if="$store.state.session.err && $store.state.session.err.email"
              >{{ $store.state.session.err.msg }}</span
            >
          </b-form-group>
          <b-form-group :label="$t('name')" label-for="name">
            <b-form-input
              type="text"
              name="name"
              :state="stateName"
              v-model.trim="form.name"
            ></b-form-input>
          </b-form-group>
          <b-form-group :label="$t('city')" label-for="city">
            <vue-google-autocomplete
              id="map"
              class="form-control"
              placeholder
              v-on:placechanged="getAddressData"
              v-on:blur="getAddressData"
              country="ua"
              types="(cities)"
            ></vue-google-autocomplete>
          </b-form-group>
          <b-form-group label="Телефон:" label-for="phone">
            <b-input-group prepend="+38">
              <b-form-input
                type="tel"
                name="phone"
                v-mask="'(###) ###-####'"
                :state="statePhone"
                v-model.trim="form.phone"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
          <b-form-group label="Пароль:" label-for="password">
            <b-form-input
              type="password"
              name="password"
              :state="statePassword"
              v-model.trim="form.password"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            :label="$t('confirmPassword')"
            label-for="password-confirm"
          >
            <b-form-input
              type="password"
              name="password-confirm"
              :state="statePassword"
              v-model.trim="form.passwordConfirm"
            ></b-form-input>
          </b-form-group>
          <span class="text-danger" v-if="$store.state.session.err">{{
            $store.state.session.err.msg
          }}</span>
          <b-form-group class="text-right">
            <b-btn class="btn btn-default" type="button" @click="hideModal">{{
              $t("close")
            }}</b-btn>
            <b-btn class="btn btn-primary btn-reg" type="submit">{{
              $t("done")
            }}</b-btn>
          </b-form-group>
        </b-form>
      </div>
    </b-modal>
  </div>
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";

export default {
  computed: {
    stateEmail() {
      if (this.form.email != "") {
        var re = new RegExp(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
        return re.test(String(this.form.email).toLowerCase()) ? true : false;
      } else {
        return null;
      }
    },
    stateName() {
      if (this.form.name !== "") {
        return this.form.name >= 2;
      } else {
        return null;
      }
    },
    statePhone() {
      if (this.form.phone !== "") {
        const pattern = new RegExp(
          /^\(?(039|067|068|096|097|098|050|066|095|099|063|073|093|091|092|094)\)?(\s+)?[0-9]{3}-?[0-9]{2}-?[0-9]{2}$/
        );
        return pattern.test(String(this.form.phone).toLowerCase());
      } else {
        return null;
      }
    },
    statePassword() {
      if (this.form.password || this.form.passwordConfirm) {
        if (this.form.password === this.form.passwordConfirm) {
          return true;
        } else {
          return false;
        }
      } else {
        return null;
      }
    }
  },
  data() {
    return {
      form: {
        email: "",
        name: "",
        city: "",
        phone: "",
        password: "",
        passwordConfirm: ""
      }
    };
  },
  methods: {
    showModal() {
      this.$refs.modal.show();
    },
    hideModal() {
      this.$store.state.session.err = null;
      this.$refs.modal.hide();
    },
    sendReg() {
      this.$store.state.session.err = null;
      this.$auth.reg(this);
    },
    getAddressData: function(addressData) {
      let target = document.getElementById("map");
      this.form.city = addressData;
      if (this.form.city) {
        target.className = "form-control is-valid";
      } else {
        target.className = "form-control is-invalid";
      }
    }
  },
  components: {
    VueGoogleAutocomplete
  }
};
</script>

<style src="@/assets/css/modal.css"></style>
